import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import React from 'react';
import { Button, Dropdown } from '@edgebox/react-components';

/**
 * Icon-only toggle for the kebab menu.
 *
 * A `<button>`, not an `<a href="">`: it opens a menu rather than navigating, so it needs
 * no `preventDefault` dance and gets correct keyboard and screen-reader behaviour for
 * free. Styling comes from Tailwind utility classes directly, not Bootstrap's `.btn
 * .btn-light`, which `@edgebox/react-components` does not emit.
 *
 * `Dropdown.Toggle` forwards `className`, `id`, `aria-expanded`, `aria-haspopup` and
 * the rest, so everything is spread straight onto the button.
 */
const CustomToggle = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ children, className, ...props }, ref) => (
    <button
      {...props}
      ref={ref}
      type="button"
      aria-label="Actions"
      className={`inline-flex items-center justify-center rounded px-2 py-1 text-base text-dark transition-colors hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${
        className || ''
      }`}
    >
      {children}
    </button>
  )
);
CustomToggle.displayName = 'CustomToggle';

export function MenuButton({ children, onClick }: { onClick: () => void; children: React.ReactNode }) {
  return (
    <Button variant="link" className="text-muted px-3 py-2 d-block w-100 text-start text-decoration-none fs-5" onClick={onClick}>
      {children}
    </Button>
  );
}

export function KebabMenu({ children }: { children: React.ReactNode }) {
  return (
    <Dropdown align="end">
      <Dropdown.Toggle as={CustomToggle} id="dropdown-actions">
        <FontAwesomeIcon icon={faEllipsisV} size="2x" />
      </Dropdown.Toggle>

      {children}
    </Dropdown>
  );
}
